import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "auth-wrapper-inner columns is-gapless" }
const _hoisted_2 = { class: "column is-4" }
const _hoisted_3 = { class: "hero is-fullheight is-white" }
const _hoisted_4 = { class: "hero-body" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "columns" }
const _hoisted_7 = { class: "column is-12" }
const _hoisted_8 = { class: "auth-form-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ForgotForm = _resolveComponent("ForgotForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"column login-column is-8 h-hidden-mobile h-hidden-tablet-p hero-banner\" data-v-4fa5fb94><div class=\"hero login-hero is-fullheight is-app-grey\" data-v-4fa5fb94><div class=\"hero-body\" data-v-4fa5fb94><div class=\"columns\" data-v-4fa5fb94></div></div><div class=\"hero-footer\" data-v-4fa5fb94><p class=\"has-text-centered\" data-v-4fa5fb94></p></div></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "hero-heading" }, null, -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "auth-content" }, [
                  _createElementVNode("h2", null, "Recover account"),
                  _createElementVNode("p", null, "Please enter email to reset account password")
                ], -1)),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_ForgotForm)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}